// This file was generated. All changes will be lost.
// Your changes will be lost.

export class ApiSettings {

	public static ApiUrl : string = "https://api-hub.endeavorco.com/";
	public static AzureAudience : string = "https://imgworld.onmicrosoft.com/b35a7ae3-3914-499d-8b2c-5e922fbe6f5a";
	public static AzureAuthority : string = "https://login.microsoftonline.com/imgworld.onmicrosoft.com";
	public static AzureClientId : string = "9f7a24d3-12d7-457b-8f5b-441ab2b91d55";
	public static Environment: string = "Live";
}
